export default __webpack_public_path__ + "static/media/free-iphone.ad415b55.png";